import { useGetGlobalQuery } from '@/graphql/generated';

export const useGlobal = (locale: string) =>
  useGetGlobalQuery({
    locale,
  }).data?.global?.data?.attributes!;
